"use client";

import { useCookieConsent } from "@klarify/ui/hooks";
import { GoogleTagManager } from "@next/third-parties/google";
import { GTMBodyIframe } from "./gtm-body";

export function GTMScriptsWrapper({
	nonce,
	gtmId,
}: {
	nonce?: string;
	gtmId: string;
}) {
	const { consent } = useCookieConsent();

	if (consent !== "ACCEPTED") {
		return null;
	}
	return (
		<>
			<GoogleTagManager
				gtmId={gtmId}
				nonce={nonce}
			/>
			<GTMBodyIframe gtmId={gtmId} />
		</>
	);
}
